// StreakLedgerItem.jsx

import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const MODULE_ICON = {
    PurpleDoor:  "🟣",
    LifeReplay:  "🔁",
    FindItLocal: "🏪",
    Learning:    "📚",
    Hustle:      "💼",
    Others:      "✨",
};

const StreakLedgerItem = ({ item, selected, setSelected }) => {
    const isIn       = item.inOutType === "In";
    const isSelected = selected?._id === item._id;

    return (
        <div className="space-y-1 bg-gray-900 px-2 py-0.5 rounded-xl text-white border-b border-cyan-200">
        <motion.div
            layout
            className="border-t border-gray-800/60 first:border-t-0"
        >
            <button
                onClick={() => setSelected(isSelected ? null : item)}
                className="w-full text-left p-3 hover:bg-gray-800/30 transition-colors"
            >
                <div className="flex items-center justify-between gap-3">

                    {/* Left: icon + text */}
                    <div className="flex items-center gap-2 min-w-0">
                        <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 text-sm ${
                            isIn
                                ? "bg-green-900/40 border border-green-700/30"
                                : "bg-red-900/40   border border-red-700/30"
                        }`}>
                            {MODULE_ICON[item.streakModule] || "⚡"}
                        </div>
                        <div className="min-w-0">
                            <div className="text-xs font-semibold text-white truncate">
                                {item.particulars}
                            </div>
                            <div className="text-[10px] text-gray-100">
                                📅 {new Date(item.streakBankDate).toLocaleDateString("en-IN")}
                                {item.shopName && ` · 🏪 ${item.shopName}`}
                            </div>
                        </div>
                    </div>

                    {/* Right: balance */}
                    <div className={`font-black text-sm flex-shrink-0 ${
                        isIn ? "text-green-400" : "text-red-400"
                    }`}>
                        {isIn ? "+" : "-"}{Math.abs(item.balance || item.points || 0)}
                    </div>
                </div>
            </button>

            {/* Expandable detail */}
            <AnimatePresence>
                {isSelected && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        className="overflow-hidden"
                    >
                        <div className="mx-3 mb-3 bg-gray-800/60 border border-gray-700/40 rounded-xl p-3 space-y-1.5">
                            <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-[11px] text-gray-100">
                                <div>
                                    <span className="text-gray-100">Module: </span>
                                    {item.streakModule}
                                </div>
                                <div>
                                    <span className="text-gray-100">Type: </span>
                                    {item.streakType}
                                </div>
                                {/* FIX: field was 'srreakFromDate' — now 'streakFromDate' */}
                                {item.streakFromDate && (
                                    <div>
                                        <span className="text-gray-100">From: </span>
                                        {new Date(item.streakFromDate).toLocaleDateString("en-IN")}
                                    </div>
                                )}
                                {item.streakToDate && (
                                    <div>
                                        <span className="text-gray-100">To: </span>
                                        {new Date(item.streakToDate).toLocaleDateString("en-IN")}
                                    </div>
                                )}
                                {item.shopkeeperCode && (
                                    <div className="col-span-2">
                                        <span className="text-gray-100">Merchant: </span>
                                        {item.shopName || item.shopkeeperName} ({item.shopkeeperCode})
                                    </div>
                                )}
                            </div>
                            {item.remarks && (
                                <div className="text-[10px] text-gray-100 pt-1 border-t border-gray-700/40">
                                    {item.remarks}
                                </div>
                            )}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.div>
        </div>
    );
};

export default StreakLedgerItem;
